/** A list of available note activities for a drop down. */
const NOTE_ACTIVITIES = [
    { key: 'none', display: 'No activity' },
    { key: 'call-in', display: 'Received call' },
    { key: 'call-out', display: 'Made call' },
    { key: 'email-in', display: 'Received email' },
    { key: 'email-out', display: 'Sent email' },
    { key: 'sms-in', display: 'Received text message' },
    { key: 'sms-out', display: 'Sent text message' },
    { key: 'in-person', display: 'Walk-In' }
]

/** A list of combined acitivies to use in note filters. */
const NOTE_ACTIVITY_FILTERS = [
    { key: 'none', display: 'No activity' },
    { key: 'call-in,call-out', display: 'Phone calls' },
    { key: 'email-in,email-out', display: 'Emails' },
    { key: 'sms-in,sms-out', display: 'Text messages' },
    { key: 'in-person', display: 'Walk-In' }
]

module.exports = {
    NOTE_ACTIVITIES,
    NOTE_ACTIVITY_FILTERS
}